/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} Formatted phone number
 */
/* global globalThis */
export const formatPhoneNumber = (phone, showPHI = false) => {
  let enabled;
  if (typeof showPHI === "boolean") {
    enabled = showPHI;
  } else if (globalThis.window === undefined) {
    enabled = false;
  } else {
    enabled = !!globalThis.window.showPHI;
  }

  const cleaned = String(phone).replaceAll(/\D/g, "");

  // if PHI allowed → return full formatted number
  if (enabled) {
    if (cleaned.length < 10) return phone;

    const areaCode = cleaned.slice(0, 3);
    const firstThree = cleaned.slice(3, 6);
    const lastFour = cleaned.slice(6, 10);

    return `(${areaCode}) ${firstThree}-${lastFour}`;
  }

  // masking mode
  if (cleaned.length < 2) return cleaned;

  const lastTwo = cleaned.slice(-2);

  return `(***) ***-**${lastTwo}`;
};

export const emailValidationRegex =
  /^[A-Za-z0-9]+([._%+-][A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

export const isValidEmail = (value) => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return emailValidationRegex.test(trimmed);
};

// Truncates display text to a character limit, appending an ellipsis when it
// was actually cut short - used for read-only previews of long free-text
// fields (notes, descriptions) where the full text is shown elsewhere (e.g.
// a tooltip or the edit modal itself).
export const truncateText = (str, limit) => {
  if (!str) return "";
  return str.length > limit ? `${str.slice(0, limit).trimEnd()}...` : str;
};

export const truncateToByteLimit = (str, limit) => {
  if (!str) return "";
  let truncatedByChar = str.slice(0, limit);
  if (typeof TextEncoder === "undefined") {
    while (new Blob([truncatedByChar]).size > limit) {
      truncatedByChar = truncatedByChar.slice(0, -1);
    }
  } else {
    const encoder = new TextEncoder();
    while (encoder.encode(truncatedByChar).length > limit) {
      truncatedByChar = truncatedByChar.slice(0, -1);
    }
  }
  return truncatedByChar;
};

export const getByteLength = (str) => {
  if (!str) return 0;
  if (typeof TextEncoder !== "undefined") {
    return new TextEncoder().encode(str).length;
  }
  return new Blob([str]).size;
};
export const formatSourceLabel = (value) => {
  if (!value) return value;
  if (value === "SCRIPTCO") return "ScriptCo";
  if (value === "TOP_TIER") return "Top Tier";
  return value;
};

/**
 * Removes any trailing characters found in `chars` (linear time, no regex backtracking)
 */
export const stripTrailingChars = (str, chars) => {
  let end = str.length;
  while (end > 0 && chars.includes(str[end - 1])) end--;
  return str.slice(0, end);
};
